import { contrastRatio, HSLColor } from '@yola/yola-palette-generator';
import reduceColorPointByStep from '../../../../../common/utils/reduce-color-point-by-step';

const light = (params) => {
  const { targetColor, backgroundColor, targetColorPalette, lightColorPalette } = params;
  const fallback = {
    rule: 'filePicker.button.border.default.light',
    params,
  };
  if (contrastRatio(backgroundColor, lightColorPalette[900]) >= 1.3) {
    return reduceColorPointByStep({
      targetColor,
      targetColorPalette,
      step: 1,
      fallback,
    });
  }

  const { hue, saturation, lightness, alpha } = targetColor;
  return new HSLColor(hue, saturation, lightness, alpha);
};
export default light;
